export enum FpnaDataType {
  ACTUALS = 'actuals',
  PLAN = 'plan',
  COMPARISON_ACTUALS = 'comparison_actuals',
  COMPARISON_PLAN = 'comparison_plan',
  COMPARISON_FORECAST = 'comparison_forecast',
  COMPARISON_DIFF = 'comparison_diff',
  COMPARISON_AIPO = 'comparison_aipo',
  COMPARISON_PIPO = 'comparison_pipo',
  COMPARISON_DIPO = 'comparison_dipo',
}

export interface GridDateRange {
  startDate: { month: number; year: number }
  endDate: { month: number; year: number }
}
